import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../actions';
//import icons from '../../data/icons';

// import SubNav from '../SubNav/SubNav';

import './HorizontalNav.css';

class HorizontalNav extends React.Component {

	onClick(index, event) {
		this.props.goToSection(index);
		if(event) {
			event.preventDefault(); //preventing bug on web
		}
	}

	exitApp() {
		if(window.require) {
			const { app } = window.require('electron').remote;
			app.quit();
		}
	}

	render() {
		return (
			<nav className="horizontalNav">
				{
					this.props.navItems.map((item, i) => (
						<a
							key={'navItemLink-'+i}
							className={`horizontalNav__item ${this.props.currentSection === i ? 'isActive' : ''}`}
							onClick={this.onClick.bind(this, i, item.subNav)}
						>
							<span className={'horizontalNav__link'}>
								{item.label}
							</span>
						</a>
					)).concat([
						<a 
							key={'navItemLink-'+this.props.navItems.length}
							className={'horizontalNav__exitButton ' + ((!window.require && ' hidden') || '')} id="exit-button" onClick={() => this.exitApp()}>
							<span>Exit</span>
							<img className={'horizontalNav__exitIcon'} alt={'exit'} src="./assets/ui/iconCrossOver.png" />
						</a>
					])
				}
			</nav>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentStage: state.navigation.currentStage,
		currentSection: state.navigation.currentSection,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		goToSection: (sectionID) => {
			dispatch(actions.goToSection(sectionID));
		},
		goToGroup: (groupID) => {
			dispatch(actions.goToGroup(groupID));
		},
		goToStage: (stageID) => {
			dispatch(actions.goToStage(stageID));
		},
	};
}

HorizontalNav.propTypes = {
	goToSection: propTypes.func.isRequired,
	goToGroup: propTypes.func.isRequired,
	goToStage: propTypes.func.isRequired,

	currentStage: propTypes.number,
	currentGroup: propTypes.number.isRequired,
	currentSection: propTypes.number.isRequired,

	navItems: propTypes.array.isRequired,
	title: propTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(HorizontalNav);



// WEBPACK FOOTER //
// ./src/components/HorizontalNav/HorizontalNav.js